import { ChecklistIcon, CouponIcon, StackIcon, UserIcon } from "@xola/icons";
import React from "react";
import { Permission, Purchase, Traveler } from "types";
import { getTotalGuests, isCouponApplied, isStoreCredit } from "../../../models/Purchase";
import { Currency } from "../../Common/Currency";
import { IsGranted } from "../../Common/IsGranted";
import { NoTranslate } from "../../Common/NoTranslate";

export const ContactPurchaseInformation = ({ purchases, contact }: { purchases: Purchase[]; contact: Traveler }) => {
    const purchaseInformation = {
        totalAmount: 0,
        totalGuests: 0,
        totalBookings: 0,
        couponUse: 0,
        storeCredit: 0,
    };
    for (const purchase of purchases) {
        purchaseInformation.totalGuests += getTotalGuests(purchase);

        if (!isStoreCredit(purchase)) {
            purchaseInformation.totalBookings += 1;
        }

        if (isCouponApplied(purchase)) {
            purchaseInformation.couponUse += 1;
        }
    }

    purchaseInformation.totalAmount = contact.lifetimeValue ?? contact.value ?? 0;
    purchaseInformation.storeCredit = contact.storeCredit?.amount ?? 0;

    return (
        <div className="space-y-4 rounded border border-gray-light py-4 px-14">
            <div className="flex items-center justify-between space-x-6">
                <div className="text-center">
                    <h2 data-testid="contact-purchase-information-total-amount">
                        <Currency>{purchaseInformation.totalAmount}</Currency>
                    </h2>
                    <div>
                        <StackIcon className="mr-1" />
                        Total Value
                    </div>
                </div>

                <IsGranted permissions={Permission.STORE_CREDIT_VIEW}>
                    <div className="text-center">
                        <h2 data-testid="contact-purchase-information-store-credit-amount">
                            <Currency>{purchaseInformation.storeCredit}</Currency>
                        </h2>
                        <div>
                            <StackIcon className="mr-1" />
                            Store Credit
                        </div>
                    </div>
                </IsGranted>

                {contact.isOrganizer && (
                    <div className="text-center">
                        <h2 data-testid="contact-purchase-information-total-guests">
                            <NoTranslate>{purchaseInformation.totalGuests}</NoTranslate>
                        </h2>
                        <div>
                            <UserIcon className="mr-1" />
                            Guest(s)
                        </div>
                    </div>
                )}

                <div className="text-center">
                    <h2 data-testid="contact-purchase-information-total-bookings">
                        <NoTranslate>{purchaseInformation.totalBookings}</NoTranslate>
                    </h2>
                    <div>
                        <ChecklistIcon className="mr-1" />
                        Purchase(s)
                    </div>
                </div>

                {contact.isOrganizer && (
                    <div className="text-center">
                        <h2 data-testid="contact-purchase-information-coupon-use">
                            <NoTranslate>{purchaseInformation.couponUse}</NoTranslate>
                        </h2>
                        <div>
                            <CouponIcon className="mr-1" />
                            Coupon(s) used
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
